import React from "react";
import { ResponsiveBar } from "@nivo/bar";

const set = [
   [2,18,3,1],
   [3,16,4,1],
   [2,19,2,1],
]
const createItems = () => {
    let items = []
    var today = new Date();
    var dd = today.getDate();

    for(var i=1; i<=31; i++) {
        if(i >= dd) {
            items.push({
                date: i,
                วิ่ง: 0,
                ดับเครื่อง: 0,
                จอดไม่ดับเครื่อง: 0,
                ไม่ส่งข้อมูล: 0,
            })
        } else {
            let ran = Math.floor(Math.random() * 2)
            items.push({
                date: i,
                วิ่ง: set[ran][0],
                ดับเครื่อง: set[ran][1],
                จอดไม่ดับเครื่อง: set[ran][2],
                ไม่ส่งข้อมูล: set[ran][3],
            })
        }
    }

    return items
}
  
const EngineSummaryGraph = ({ data }) =>  (
    <ResponsiveBar
      data={createItems()}
      keys={["วิ่ง", "ดับเครื่อง", "จอดไม่ดับเครื่อง", "ไม่ส่งข้อมูล"]}
      indexBy="date"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      maxValue={24}
      colors={['#57df4e', '#ff3b30', '#f2bf33', "#b0b0b0"]}
      borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "วันที่",
        legendPosition: "middle",
        legendOffset: 32,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "เวลา",
        legendPosition: "middle",
        legendOffset: -40,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
    />
  );

export default EngineSummaryGraph;
